// extracted by mini-css-extract-plugin
module.exports =  {"tag":"tag--CeGg8","success":"success--w5ST0","primary":"primary--HQQog","danger":"danger--bUjCv","neutral":"neutral--Zaukz","error":"error--Ru2hj","secondary":"secondary--IGJNT"};